import { LaptopRegular, DesktopSignalRegular, NetworkCheckRegular } from '@fluentui/react-icons'
import { CapabilityCard } from '@/components/common/CapabilityCard'
import { PanelShell } from './PanelShell'
import grid from './PanelGrid.module.css'

interface PanelProps {
  onOpenWorkspace: () => void
}

export function EndpointsPanel({ onOpenWorkspace }: PanelProps) {
  return (
    <PanelShell
      icon={LaptopRegular}
      title="Endpoints"
      subtitle="Defender device posture, alerts and endpoint activity from Microsoft Defender for Endpoint."
      onOpenWorkspace={onOpenWorkspace}
    >
      <div className={grid.grid}>
        <CapabilityCard
          icon={LaptopRegular}
          eyebrow="Posture"
          title="Device posture & alerts"
          points={['Defender device posture', 'Endpoint alerts']}
        />
        <CapabilityCard
          icon={DesktopSignalRegular}
          eyebrow="Activity"
          title="Process & logon activity"
          points={['Process activity', 'Logon activity']}
        />
        <CapabilityCard
          icon={NetworkCheckRegular}
          eyebrow="Telemetry"
          title="Network activity & coverage"
          points={['Network activity', 'Telemetry coverage — what signal is and isn\u2019t available']}
        />
      </div>
    </PanelShell>
  )
}
